exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table.unassigned-trajectories-table tr:first-child td, table.unassigned-trajectories-table tr:first-child th {\n  text-align: left;\n  border-top: none;\n}\ntable.unassigned-trajectories-table td, table.unassigned-trajectories-table th {\n  padding-left: 0px !important;\n}\n.action_icon {\n  color: #5A4587 !important;\n}\n.action_icon:hover {\n  color: #9b89c3 !important;\n}\n.card-block {\n  position: relative;\n  min-height: 75px;\n}\n", ""]);

// exports
